import useAuth from '../../component/useAuth';
import Template from '../../component/Template';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";

import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Loader from '../../component/Loader.js';


export default function CollegeStudentCOAttainment() {

  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/")
  }
  const { http } = Api();

  const tableRef = useRef(null);
  const [selectedExamId, setSelectedExamId] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [tableData, setTableData] = useState({});
  const [collegeLevelCOAttainmentData, setCollegeLevelCOAttainmentData] = useState([]);
  const [universityLevelCOAttainmentData, setUniversityLevelCOAttainmentData] = useState([]);

  const [deactiveTab, setdeActiveTab] = useState([]);
  const [loading, setloading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [scheme, setScheme] = useState([]);


  const { eid, acid } = useParams();  // Get encoded IDs from URL
  const decodedExamID = parseInt(atob(eid), 10);    // Decode and convert to integer
  const decodedAccountID = parseInt(atob(acid), 10); // Decode and convert to integer

   useEffect(() => {
    const getscheme = () => {
      http
        .get('College/getscheme', {
          params: {
            examid: decodedExamID,
        
          }
        })
        .then((response) => {

          setScheme(response.data.scheme);
       

        })
        .catch((error) => {
          const status = error.response?.data?.http_status;
          if (status === 401 && error.response?.data?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/"), 5000);
          } 
        });
    };
  
    getscheme();
    
  }, [decodedExamID]);

  console.log(scheme);

  useEffect(() => {
    const collegeCOAttainmentInCollegeLevel = () => {
      http
        .get('College/getCollegeStudentcoAttainmentStudentLevel', {
          params: {
            examid: decodedExamID,
            accountid: decodedAccountID

          }
        })
        .then((response) => {
          setTableData(response.data.result.courses);
          setStudentData(response.data.result.studentdetails);

        })
        .catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "Something went wrong";

          if (status === 401 && error.response?.data?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/"), 5000);
          } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
            toast.error(message);
          } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
            toast.error("CO-Student-Level data not found");
          } else {
            toast.error(message);
          }
        });
    };
    const studentCOAttainmentInCollegeLevel = () => {
      http
        .get('College/getCollegeStudentcoAttainmentCollegeLevel', {
          params: {
            examid: decodedExamID,
            accountid: decodedAccountID

          }
        })
        .then((response) => {
          setCollegeLevelCOAttainmentData(response.data.result);
        })
        .catch((error) => {
          const status = error.response?.data?.http_status;
          const message = error.response?.data?.message || "Something went wrong";

          if (status === 401 && error.response?.data?.status_code === "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => navigate("/"), 5000);
          } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
            toast.error(message);
          } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
            toast.error("CO-College-Level data not found");
          } else {
            toast.error(message);
          }
        });
    };

    const universityCOAttainmentInCollegeLevel = () => {
      http.get('/College/getCollegeStudentcoAttainmentUniversityLevel', {
        params: {
          examid: decodedExamID,
          accountid: decodedAccountID
        }
      }).then((response) => {

        setUniversityLevelCOAttainmentData(response.data.result);

      }).catch((error) => {

        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "Something went wrong";

        if (status === 401 && error.response?.data?.status_code === "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/"), 5000);
        } else if (status === 429 && error.response?.data?.status_code === "ERR33") {
          toast.error(message);
        } else if (status === 500 && error.response?.data?.status_code === "ERR5") {
          toast.error("CO-University-Level data not found");
        } else {
          toast.error(message);
        }
      });
    };


    collegeCOAttainmentInCollegeLevel();
    studentCOAttainmentInCollegeLevel();
    universityCOAttainmentInCollegeLevel();
  }, []);


  const toggleAccordion = (tab) => {

    setdeActiveTab(tabs => {
      if (tabs.includes(tab)) {
        return tabs.filter(t => t !== tab);
      } else {
        return [...tabs, tab];
      }
    });
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  const handleGeneratePDF = async (examid) => {
    setloading(true);

    try {
      const response = await http.get('/College/StudentCOAttainPdf', {
        params: {

          accountid: decodedAccountID,
          examid: examid
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `StudentCOAttainment.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setloading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      setloading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/");
        }, 5000);

      }
      else if (error.response.status === 403 || error.response.data.status_code == "ERR37") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/");
        }, 5000);
      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        //console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };

  const toggleScoreAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <ToastContainer /> {/*  to display toast */}
      <Template>

        {loading ? (
          <>

            { /*<div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */ }
            <Loader />
          </>
        ) : (

          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header card-heading">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5 className="lbl1">MGU-UGP/BBA/BCA(HONOURS) CO ATTAINMENT CALCULATION CHART</h5>
                    </div>
                  </div>
                  <div className="card-body">

                    <div className="table-responsive">

                      <div>
                        <table className="table ex-table1 m-b-30 table-striped" style={{ width: "100%", fontSize: "0.85rem" }}>

                          <thead>

                            <tr>
                              <th style={{ textAlign: 'center' }}>
                                APAAR No: {studentData.apaar_no} | PRN: {studentData.PRN} | Student Name: {studentData.studentname}
                              </th>
                            </tr>
                          </thead>
                        </table>
                      </div>

                      {tableData && Object.keys(tableData).length > 0 && (
                        <div className="buttons-container m-b-20 nav-right">

                          <button
                            className="lbl2 btn btn-primary mt-3"
                            onClick={() => handleGeneratePDF(decodedExamID)}
                            title="Download"
                          >
                            <i class="bi bi-arrow-down-square"></i>
                          </button>


                        </div>
                      )}
                      {tableData && Object.keys(tableData).length > 0 && (
                        <div className="accordion dark-accordion m-b-30" id="scoreAccordion">
                          <div className="accordion-item accordion-wrapper">
                            <div className="acodn-bot-line">
                              <h2 className="accordion-header" style={{ background: "#c7e5ff" }}>
                                <button
                                  className="accordion-button txt-primary accordion-light-primar"
                                  type="button"
                                  onClick={toggleScoreAccordion}
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  Score Info &nbsp;<i className="bi bi-info-circle"></i>
                                  <i className={`bi ${isOpen ? "bi-chevron-up" : "bi-chevron-down"} svg-color`}></i>
                                </button>
                              </h2>
                              {isOpen && scheme.some(s => s.scheme_id === 1) ? (
                                <div className="accordion-collapse show">
                                  <div className="accordion-body">
                                    <div className="table-responsive signal-table">
                                      <h5
                                        className="sub-h5"
                                        style={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
                                      >
                                        Student Level CO Attainment
                                      </h5>

                                      <table className="table-striped new-stl-table new-stl-table-wt">
                                        <thead>
                                          <tr style={{ fontWeight: "bold", fontSize: "9px" }}>
                                            <th style={{ textAlign: "center", width: '20%' }} >Level</th>
                                            <th style={{ textAlign: "center" }}>CCA</th>
                                            <th style={{ textAlign: "center" }}>ESE</th>
                                            <th style={{ textAlign: "center" }}>Overall</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>1</td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 0 and &lt; 40% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 45% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 0 and &lt; 30% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 35% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 0 and &lt; 35% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 40% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>2</td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 45% &gt;= and &lt; 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 30% &gt;= and &lt; 70% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 35% and &lt; 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 35% &gt;= and &lt; 75% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>3</td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores &gt;= 80% Marks (For MGU UGP)<br />
                                              {/* If the student scores &gt;= 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores &gt;= 70% Marks (For MGU UGP)<br />
                                              {/* If the student scores &gt;= 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores &gt;= 75% Marks (For MGU UGP)<br />
                                              {/* If the student scores &gt;= 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                    </div>

                                    <div className="table-responsive signal-table m-t-15">
                                      <h5
                                        className="sub-h5"
                                        style={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
                                      >
                                        College Level CO Attainment
                                      </h5>

                                      <table className="table-striped new-stl-table new-stl-table-wt">
                                        <thead>
                                          <tr style={{ fontWeight: "bold", fontSize: "9px" }}>
                                            <th style={{ textAlign: "center", width: '20%' }} >Level</th>
                                            <th style={{ textAlign: "center" }}>CCA</th>
                                            <th style={{ textAlign: "center" }}>ESE</th>
                                            <th style={{ textAlign: "center" }}>Overall</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>1</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 60% Marks (For MGU UGP) <br />
                                              {/* If the student scores between 0 and &lt; 45% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 50% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 35% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 55% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 40% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>2</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 60% Marks (For MGU UGP) <br />
                                              {/* If the student scores between 45% &gt;= and &lt; 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 50% Marks (For MGU UGP) <br />
                                              {/* If the student scores between 35% and &lt; 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 55% Marks (For MGU UGP) <br />
                                              {/* If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>3</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 60% Marks (For MGU UGP)<br />
                                              {/* If the student scores &gt;= 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 50% Marks (For MGU UGP) <br />
                                              {/* If the student scores &gt;= 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 55% Marks (For MGU UGP)<br />
                                              {/* If the student scores &gt;= 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                    </div>

                                    <div className="table-responsive signal-table m-t-15">
                                      <h5
                                        className="sub-h5"
                                        style={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
                                      >
                                        University Level CO Attainment
                                      </h5>

                                      <table className="table-striped new-stl-table new-stl-table-wt">
                                        <thead>
                                          <tr style={{ fontWeight: "bold", fontSize: "9px" }}>
                                            <th style={{ textAlign: "center", width: '20%' }} >Level</th>
                                            <th style={{ textAlign: "center" }}>CCA</th>
                                            <th style={{ textAlign: "center" }}>ESE</th>
                                            <th style={{ textAlign: "center" }}>Overall</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>1</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 60% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 45% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 50% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 35% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 55% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 0 and &lt; 40% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>2</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 60% Marks (For MGU UGP) <br />
                                              {/* If the student scores between 45% &gt;= and &lt; 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 50% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 35% and &lt; 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 55% Marks (For MGU UGP)<br />
                                              {/* If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>3</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 60% Marks (For MGU UGP)<br />
                                              {/* If the student scores &gt;= 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 50% Marks (For MGU UGP) <br />
                                              {/* If the student scores &gt;= 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 55% Marks (For MGU UGP)<br />
                                              {/* If the student scores &gt;= 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                    </div>
                                  </div>

                                </div>
                              ) : (isOpen && scheme.some(s => s.scheme_id === 2 || s.scheme_id === 3) && (

                                <div className="accordion-collapse show">
                                  <div className="accordion-body">
                                    <div className="table-responsive signal-table">
                                      <h5
                                        className="sub-h5"
                                        style={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
                                      >
                                        Student Level CO Attainment
                                      </h5>

                                      <table className="table-striped new-stl-table new-stl-table-wt">
                                        <thead>
                                          <tr style={{ fontWeight: "bold", fontSize: "9px" }}>
                                            <th style={{ textAlign: "center", width: '20%' }} >Level</th>
                                            <th style={{ textAlign: "center" }}>CCA</th>
                                            <th style={{ textAlign: "center" }}>ESE</th>
                                            <th style={{ textAlign: "center" }}>Overall</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>1</td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 0 and &lt; 45% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 0 and &lt; 45% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 0 and &lt; 35% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 0 and &lt; 35% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 0 and &lt; 40% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 0 and &lt; 40% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>2</td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 45% &gt;= and &lt; 85% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 45% &gt;= and &lt; 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 35% &gt;= and 75% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 35% and &lt; 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>3</td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores &gt;= 85% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores &gt;= 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores &gt;= 75% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores &gt;= 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              If the student scores &gt;= 80% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores &gt;= 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                    </div>

                                    <div className="table-responsive signal-table m-t-15">
                                      <h5
                                        className="sub-h5"
                                        style={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
                                      >
                                        College Level CO Attainment
                                      </h5>

                                      <table className="table-striped new-stl-table new-stl-table-wt">
                                        <thead>
                                          <tr style={{ fontWeight: "bold", fontSize: "9px" }}>
                                            <th style={{ textAlign: "center", width: '20%' }} >Level</th>
                                            <th style={{ textAlign: "center" }}>CCA</th>
                                            <th style={{ textAlign: "center" }}>ESE</th>
                                            <th style={{ textAlign: "center" }}>Overall</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>1</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 65% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 0 and &lt; 45% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 55% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 0 and &lt; 35% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 60% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 0 and &lt; 40% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>2</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 65% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 45% &gt;= and &lt; 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 55% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 35% and &lt; 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 60% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>3</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 65% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores &gt;= 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 55% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores &gt;= 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 60% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores &gt;= 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                    </div>

                                    <div className="table-responsive signal-table m-t-15">
                                      <h5
                                        className="sub-h5"
                                        style={{ textAlign: "center", fontWeight: "bold", color: "#333" }}
                                      >
                                        University Level CO Attainment
                                      </h5>

                                      <table className="table-striped new-stl-table new-stl-table-wt">
                                        <thead>
                                          <tr style={{ fontWeight: "bold", fontSize: "9px" }}>
                                            <th style={{ textAlign: "center", width: '20%' }} >Level</th>
                                            <th style={{ textAlign: "center" }}>CCA</th>
                                            <th style={{ textAlign: "center" }}>ESE</th>
                                            <th style={{ textAlign: "center" }}>Overall</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>1</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 65% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 0 and &lt; 45% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 55% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 0 and &lt; 35% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &lt; 60% of the students scores &gt;= 60% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores between 0 and &lt; 40% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>2</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 65% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 45% &gt;= and &lt; 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 55% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 35% and &lt; 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 60% & &lt; 80% of the students scores &gt;= 60% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores between 40% &gt;= and &lt; 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                          <tr style={{ fontSize: "12px" }}>
                                            <td style={{ textAlign: "center" }}>3</td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 65% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores &gt;= 85% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 55% Marks (For MGU BBA & MGU BCA) <br />
                                              {/* If the student scores &gt;= 75% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                            <td style={{ textAlign: "justify" }}>
                                              &gt;= 80% of the students scores &gt;= 60% Marks (For MGU BBA & MGU BCA)<br />
                                              {/* If the student scores &gt;= 80% Marks (For MGU BBA & MGU BCA) */}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                    </div>
                                  </div>

                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                      {tableData && Object.keys(tableData).length > 0 && (
                        <div className="m-l-20">
                          <h5><b>Course Details</b></h5>
                        </div>
                      )}
                      {tableData && (Object.keys(tableData).map((coursename, index) => (
                        <div className="accordion dark-accordion" id="outlineaccordion">
                          <div className="accordion-item accordion-wrapper">
                            <div className="acodn-bot-line" key={index} >
                              <h2 className="accordion-header" style={{ background: '#c7e5ff' }}>
                                <button className="accordion-button txt-primary accordion-light-primar" type="button" onClick={() => toggleAccordion(coursename)}>

                                  {tableData[coursename][0].course_code} - {coursename}
                                  &nbsp;&nbsp;
                                  <i className={`${deactiveTab.includes(coursename) ? 'bi bi-chevron-up svg-color' : 'bi bi-chevron-down svg-color'}`}></i>

                                </button>
                              </h2>
                              <div
                                className={`accordion-collapse collapse ${deactiveTab.includes(coursename) ? 'show' : ''}`}
                                data-bs-parent="#outlineaccordion"
                              >
                                <div className="accordion-body">
                                  <div className="table-responsive signal-table">
                                    <h5 className="sub-h5 mt-3 m-20" style={{ textAlign: 'center', fontWeight: 'bold', color: '#333' }}>
                                      Student Level CO Attainment
                                    </h5>
                                    <table className=" table-striped new-stl-table new-stl-table-wt" ref={tableRef} >
                                      <thead>
                                        <tr>
                                          <th rowspan="2" style={{ width: '20%' }}>CO</th>
                                          <th rowspan="2" style={{ width: '70%' }}>Description</th>
                                          <th colspan="4" style={{ width: '80%' }}>CCA</th>
                                          <th colspan="4" style={{ width: '80%' }}>ESE</th>
                                          <th colspan="2" style={{ width: '50%' }}>Overall</th>
                                        </tr>
                                        <tr>
                                          <th>Candidate Score</th>
                                          <th>CO Maximum</th>
                                          <th>CO Attainment (%)</th>
                                          <th>CO Attainment Level</th>
                                          <th>Candidate Score</th>
                                          <th>CO Maximum</th>
                                          <th>CO Attainment (%)</th>
                                          <th>CO Attainment Level</th>
                                          <th>CO Attainment (%)</th>
                                          <th>CO Attainment Level</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Array.isArray(tableData[coursename]) && (
                                          tableData[coursename].sort((a, b) => a.outcome_slno - b.outcome_slno).map((course, courseIndex) => (
                                            <tr key={courseIndex}>
                                              <td>CO {course.outcome_slno}</td>
                                              <td class="description">{course.outcome_description}</td>
                                              <td>{course.CO_total}</td>
                                              <td>{course.co_max}</td>
                                              <td>{course.cca_percent}</td>
                                              <td>{course.cca_level}</td>
                                              <td>{course.ese}</td>
                                              <td>{course.ese_total}</td>
                                              <td>{course.ese_percent}</td>
                                              <td>{course.ese_level}</td>
                                              <td>{course.normalised_per}</td>
                                              <td>{course.overall_level}</td>
                                            </tr>
                                          )))}
                                      </tbody>
                                    </table>
                                    <h5 className="sub-h5 mt-3 m-20" style={{ textAlign: 'center', fontWeight: 'bold', color: '#333' }}>
                                      College Level CO Attainment
                                    </h5>
                                    <table className=" table-striped new-stl-table new-stl-table-wt" ref={tableRef} >
                                      <thead>
                                        <tr>
                                          <th rowspan="2" style={{ width: '20%' }}>CO</th>
                                          <th rowspan="2" style={{ width: '60%' }}>Description</th>
                                          <th colspan="4" style={{ width: '80%' }}>CCA</th>
                                          <th colspan="4" style={{ width: '80%' }}>ESE</th>
                                          <th colspan="4" style={{ width: '80%' }}>Overall</th>
                                        </tr>
                                        <tr>
                                          <th>No. of students scored &gt;= {decodedExamID === 1 ? '60%' : decodedExamID === 2 ? '65%' : ''} in CCA</th>
                                          <th>Total no. of students attended evaluation</th>
                                          <th>CO Attainment in (%)</th>
                                          <th>CO Attainment Levels</th>

                                          <th>No. of students scored &gt;= {decodedExamID === 1 ? '50%' : decodedExamID === 2 ? '55%' : ''} in ESE</th>
                                          <th>Total no. of students attended evaluation</th>
                                          <th>CO Attainment in (%)</th>
                                          <th>CO Attainment Levels</th>

                                          <th>No. of students scored &gt;= {decodedExamID === 1 ? '55%' : decodedExamID === 2 ? '60%' : ''} in Overall</th>
                                          <th>Total no. of students attended evaluation</th>
                                          <th>CO Attainment in (%)</th>
                                          <th>CO Attainment Levels</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Array.isArray(collegeLevelCOAttainmentData[coursename]) &&
                                          collegeLevelCOAttainmentData[coursename].length > 0 ? (
                                          collegeLevelCOAttainmentData[coursename]
                                            .sort((a, b) => a.outcome_slno - b.outcome_slno)
                                            .map((course, courseIndex) => (
                                              <tr key={courseIndex}>
                                                <td>CO {course.outcome_slno}</td>
                                                <td className="description">{course.outcome_description}</td>
                                                <td>{course.attain_count}</td>
                                                <td>{course.max_count}</td>
                                                <td>{course.cca_attain_percentage}</td>
                                                <td>{course.cca_level}</td>

                                                <td>{course.ese_attain_count}</td>
                                                <td>{course.ese_maxcount}</td>
                                                <td>{course.ese_attain_percentage}</td>
                                                <td>{course.ese_level}</td>

                                                <td>{course.overall_attain_count}</td>
                                                <td>{course.overall_maxcount}</td>
                                                <td>{course.overall_attain_percentage}</td>
                                                <td>{course.ovr_level}</td>
                                              </tr>
                                            ))
                                        ) : (
                                          <tr>
                                            <td colSpan="14" className="text-center">No data found</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                    <h5 className="sub-h5 mt-3 m-20" style={{ textAlign: 'center', fontWeight: 'bold', color: '#333' }}>
                                      University Level CO Attainment
                                    </h5>
                                    <table className=" table-striped new-stl-table new-stl-table-wt" ref={tableRef} >
                                      <thead>
                                        <tr>
                                          <th rowspan="2" style={{ width: '20%' }}>CO</th>
                                          <th rowspan="2" style={{ width: '60%' }}>Description</th>
                                          <th colspan="4" style={{ width: '80%' }}>CCA</th>
                                          <th colspan="4" style={{ width: '80%' }}>ESE</th>
                                          <th colspan="4" style={{ width: '80%' }}>Overall</th>
                                        </tr>
                                        <tr>
                                          <th>No. of students scored &gt;= {decodedExamID === 1 ? '60%' : decodedExamID === 2 ? '65%' : ''} in CCA</th>
                                          <th>Total no. of students attended evaluation</th>
                                          <th>CO Attainment in (%)</th>
                                          <th>CO Attainment Levels</th>

                                          <th>No. of students scored &gt;= {decodedExamID === 1 ? '50%' : decodedExamID === 2 ? '55%' : ''} in ESE</th>
                                          <th>Total no. of students attended evaluation</th>
                                          <th>CO Attainment in (%)</th>
                                          <th>CO Attainment Levels</th>

                                          <th>No. of students scored &gt;= {decodedExamID === 1 ? '55%' : decodedExamID === 2 ? '60%' : ''} in Overall</th>
                                          <th>Total no. of students attended evaluation</th>
                                          <th>CO Attainment in (%)</th>
                                          <th>CO Attainment Levels</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Array.isArray(universityLevelCOAttainmentData[coursename]) &&
                                          universityLevelCOAttainmentData[coursename].length > 0 ? (
                                          universityLevelCOAttainmentData[coursename]
                                            .sort((a, b) => a.outcome_slno - b.outcome_slno)
                                            .map((course, courseIndex) => (

                                              <tr key={courseIndex}>
                                                <td>CO {course.outcome_slno}</td>
                                                <td className="description">{course.outcome_description}</td>
                                                <td>{course.attain_count}</td>
                                                <td>{course.max_count}</td>
                                                <td>{course.cca_attain_percentage}</td>
                                                <td>{course.cca_level}</td>

                                                <td>{course.ese_attain_count}</td>
                                                <td>{course.ese_maxcount}</td>
                                                <td>{course.ese_attain_percentage}</td>
                                                <td>{course.ese_level}</td>

                                                <td>{course.overall_attain_count}</td>
                                                <td>{course.max_count}</td>
                                                {/* <td>{course.overall_maxcount}</td> */}
                                                <td>{course.overall_attain_percentage}</td>
                                                <td>{course.ovr_level}</td>
                                              </tr>
                                            ))
                                        ) : (
                                          <tr>
                                            <td colSpan="14" className="text-center">No data found</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Template>
    </>
  );
}
